export const AppEnum = {
    TERMOS_USO: 'https://www.estadao.com.br/termo-de-uso',
    POLITICA_PRIVACIDADE: 'https://www.estadao.com.br/termo-de-uso#politica-privacidade',
    OFERTA_REDIRECIONAR: 'https://ofertas.estadao.com.br/',
    PAYPAL_HABILITADO: false,
    // https://console.cloud.google.com/security/recaptcha/6LcLN1ojAAAAABV-MVjIeiNSFJaI7CZBzc9QUQQm?project=estadao-ti-prod
    RECAPTCHA_KEY: '6LcacoosAAAAAB7H7whlkWGX4GNXNwvesZHSypSe',
    // https://console.cloud.google.com/security/recaptcha/6LcEai8nAAAAALHaouQx8q6NiCHJQpkRbuLAyrGK?project=assine-389719
    INVISBLE_RECAPTCHA_KEY: '6LcacoosAAAAAB7H7whlkWGX4GNXNwvesZHSypSe'
}